import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BRAND from "../constants/brand";

/**
 * Auth surface brand header.
 *
 * Shown above the Login/Signup forms so the visual identity is
 * consistent with the rest of the ecosystem.  The logo links back
 * to the homepage to ensure the brand mark is always a “way out”.
 */
export default function AuthBrandHeader({ eyebrow, title, subtitle }) {
  const { t } = useTranslation();
  return (
    <div className="app-container pt-10 md:pt-16" data-testid="auth-brand-header">
      <Link
        to="/"
        className="inline-flex items-center gap-3 group"
        aria-label={t("nav.brand_home_aria")}
        data-testid="auth-brand-link"
      >
        <img
          src={BRAND.LOGO}
          alt="DONiTSH!T"
          width="56"
          height="56"
          className="w-14 h-14 rounded-lg object-cover ring-1 ring-[#C8A24A]/35 drop-shadow-[0_0_22px_rgba(212,175,55,0.35)] transition-transform duration-200 group-hover:scale-105"
        />
        <div className="leading-none">
          <div className="font-display text-xl tracking-tight">DONiTSH!T</div>
          <div className="text-[10px] tracking-[0.28em] gold-text uppercase mt-1">{t("nav.brand_eyebrow_long")}</div>
        </div>
      </Link>
      {(eyebrow || title || subtitle) && (
        <div className="mt-8 max-w-2xl">
          {eyebrow && <div className="eyebrow mb-3">{eyebrow}</div>}
          {title && (
            <h1 className="font-display text-3xl md:text-4xl leading-tight tracking-tight">
              {title}
            </h1>
          )}
          {subtitle && (
            <p className="mt-3 text-white/72 leading-relaxed body-copy max-w-[60ch]">
              {subtitle}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
